export const tokens = {
  alerts: {
    attention: 'alerts.attention',
    error: 'alerts.error',
    success: 'alerts.success',
    warning: 'alerts.warning',
  },
  buttons: {
    accept: 'buttons.accept',
    add: 'buttons.add',
    addTo: 'buttons.addTo',
    addToAlt: 'buttons.addToAlt',
    back: 'buttons.back',
    backHome: 'buttons.backHome',
    cancelAndBack: 'buttons.cancelAndBack',
    block: 'buttons.block',
    bulkEdit: 'buttons.bulkEdit',
    bulkStockEntry: 'buttons.bulkStockEntry',
    cancel: 'buttons.cancel',
    change: 'buttons.change',
    checkout: 'buttons.checkout',
    clear: 'buttons.clear',
    clearFilter: 'buttons.clearFilter',
    close: 'buttons.close',
    create: 'buttons.create',
    confirm: 'buttons.confirm',
    continue: 'buttons.continue',
    delete: 'buttons.delete',
    deliver: 'buttons.deliver',
    deliverTable: 'buttons.deliverTable',
    deliverTableGeneric: 'buttons.deliverTableGeneric',
    edit: 'buttons.edit',
    editLayout: 'buttons.editLayout',
    filter: 'buttons.filter',
    find: 'buttons.find',
    finish: 'buttons.finish',
    fulfill: 'buttons.fulfill',
    invite: 'buttons.invite',
    new: 'buttons.new',
    newAlt: 'buttons.newAlt',
    operate: 'buttons.operate',
    next: 'buttons.next',
    pay: 'buttons.pay',
    prepare: 'buttons.prepare',
    previous: 'buttons.previous',
    print: 'buttons.print',
    reconnect: 'buttons.reconnect',
    record: 'buttons.record',
    rememberAcc: 'buttons.rememberAcc',
    resendCodeEmail: 'buttons.resendCodeEmail',
    resendInvite: 'buttons.resendInvite',
    resendVerifEmail: 'buttons.resendVerifEmail',
    save: 'buttons.save',
    search: 'buttons.search',
    select: 'buttons.select',
    setReady: 'buttons.setReady',
    setReadyTable: 'buttons.setReadyTable',
    show: 'buttons.show',
    showMore: 'buttons.showMore',
    submit: 'buttons.submit',
    sync: 'buttons.sync',
    update: 'buttons.update',
    upload: 'buttons.upload',
    validate: 'buttons.validate',
    validateCheckin: 'buttons.validateCheckin',
    validateCheckout: 'buttons.validateCheckout',
    useCodeInstead: 'buttons.useCodeInstead',
    verify: 'buttons.verify',
    view: 'buttons.view',
    viewQR: 'buttons.viewQR',
  },
  calendar: {
    day: 'calendar.day',
    week: 'calendar.week',
    month: 'calendar.month',
    year: 'calendar.year',
  },
  components: {
    filter: 'components.filter',
    photo: 'components.photo',
    qrCode: 'components.qrCode',
    validatingQrCode: 'components.validatingQrCode',
    search: 'components.search',
    fileUpload: {
      header: 'components.fileUpload.header',
      subStart: 'components.fileUpload.subStart',
      subEnd: 'components.fileUpload.subEnd',
    },
    photoUpload: {
      header: 'components.photoUpload.header',
      subStart: 'components.photoUpload.subStart',
      subEnd: 'components.photoUpload.subEnd',
    },
  },
  charts: {
    activeSale: 'chart.activeSale',
    averagePublic: 'chart.averagePublic',
    averageTicket: 'chart.averageTicket',
    monthlyComparison: 'chart.monthlyComparison',
    publicDistribution: 'chart.publicDistribution',
    publicAgeDistribution: 'chart.publicAgeDistribution',
    saleIncome: 'chart.saleIncome',
    salesOverview: 'chart.salesOverview',
    salesPerVenue: 'chart.salesPerVenue',
    productSalesPerCategory: 'chart.productSalesPerCategory',
    productSalesRanking: 'chart.productSalesRanking',
    weeklyComparison: 'chart.weeklyComparison',
    entranceFeeIncome: 'chart.entranceFeeIncome',
    entranceFeePerWeekday: 'chart.entranceFeePerWeekday',
    entranceFeePerVenue: 'chart.entranceFeePerVenue',
    entranceFeeParticipants: 'chart.entranceFeeParticipants',
    entranceFeeAverage: 'chart.entranceFeeAverage',
  },
  common: {
    all: 'common.all',
    allDone: 'common.allDone',
    allowed: 'common.allowed',
    authorized: 'common.authorized',
    browse: 'common.browse',
    bulk: 'common.bulk',
    date: 'common.date',
    dense: 'common.dense',
    entry: 'common.entry',
    exit: 'common.exit',
    history: 'common.history',
    languageChanged: 'common.languageChanged',
    loss: 'common.loss',
    maxSize: 'common.maxSize',
    me: 'common.me',
    notAllowed: 'common.notAllowed',
    noData: 'common.noData',
    notes: 'common.notes',
    or: 'common.or',
    question: 'common.question',
    recommended: 'common.recommended',
    selected: 'common.selected',
    source: 'common.source',
    to: 'common.to',
    unauthorized: 'common.unauthorized',
    with: 'common.with',
  },
  controls: {
    created_at: 'controls.created_at',
    created_by: 'controls.created_by',
    orderHistory: 'controls.orderHistory',
    tabHistory: 'controls.tabHistory',
    updated_at: 'controls.updated_at',
    updated_by: 'controls.updated_by',
  },
  fields: {
    address: 'fields.address',
    addressProof: 'fields.addressProof',
    amount: 'fields.amount',
    area: 'fields.area',
    bankingProof: 'fields.bankingProof',
    birthDate: 'fields.birthDate',
    categoryCode: 'fields.categoryCode',
    categorySku: 'fields.categorySku',
    city: 'fields.city',
    code: 'fields.code',
    comment: 'fields.comment',
    complement: 'fields.complement',
    companyContract: 'fields.companyContract',
    cost: 'fields.cost',
    country: 'fields.country',
    description: 'fields.description',
    discount: 'fields.discount',
    districtCode: 'fields.districtCode',
    districtId: 'fields.districtId',
    drinks: 'fields.drinks',
    email: 'fields.email',
    entrance_fee: 'fields.entrance_fee',
    federalId: 'fields.federalId',
    federalIdCard: 'fields.federalIdCard',
    fees: 'fields.fees',
    firstName: 'fields.firstName',
    fiscalRegime: 'fields.fiscalRegime',
    food: 'fields.food',
    from: 'fields.from',
    gender: 'fields.gender',
    govId: 'fields.govId',
    item: 'fields.item',
    lastName: 'fields.lastName',
    legalName: 'fields.legalName',
    manager: 'fields.manager',
    min_amount: 'fields.min_amount',
    name: 'fields.name',
    notVerified: 'fields.notVerified',
    number: 'fields.number',
    openStatus: 'fields.openStatus',
    password: 'fields.password',
    paymentMethod: 'fields.paymentMethod',
    payment_mode: 'fields.payment_mode',
    paymentStatus: 'fields.paymentStatus',
    placeholders: {
      description: 'fields.placeholders.description',
      searchAddress: 'fields.placeholders.searchAddress',
    },
    price: 'fields.price',
    productCode: 'fields.productCode',
    productNcm: 'fields.productNcm',
    productSku: 'fields.productSku',
    profileAvatar: 'fields.profileAvatar',
    phone: 'fields.phone',
    quantity: 'fields.quantity',
    saleprice: 'fields.saleprice',
    sale: 'fields.sale',
    service_mode: 'fields.service_mode',
    sku: 'fields.sku',
    state: 'fields.state',
    stateId: 'fields.stateId',
    status: 'fields.status',
    stock: 'fields.stock',
    stockQuantity: 'fields.stockQuantity',
    stock_threshold: 'fields.stock_threshold',
    street: 'fields.street',
    subtotal: 'fields.subtotal',
    tableNumber: 'fields.tableNumber',
    capacity: 'fields.capacity',
    tabId: 'fields.tabId',
    taxes: 'fields.taxes',
    tip: 'fields.tip',
    to: 'fields.to',
    total: 'fields.total',
    netAmount: 'fields.netAmount',
    processorFee: 'fields.processorFee',
    platformCommission: 'fields.platformCommission',
    underVerification: 'fields.underVerification',
    unitCost: 'fields.unitCost',
    unitPrice: 'fields.unitPrice',
    verified: 'fields.verified',
    venueType: 'fields.venueType',
    weekday: 'fields.weekday',
    zipCode: 'fields.zipCode',
  },
  gender: {
    female: 'gender.female',
    male: 'gender.male',
    other: 'gender.other',
    unidentified: 'gender.unidentified',
  },
  helper: {
    higherThan: 'helper.higherThan',
    invalid: 'helper.invalid',
    invalidDate: 'helper.invalidDate',
    invalidEmail: 'helper.invalidEmail',
    invalidGovId: 'helper.invalidGovId',
    isRequired: 'helper.isRequired',
    lowerThan: 'helper.lowerThan',
    minChar: 'helper.minChar',
    minLower: 'helper.minLower',
    minNumber: 'helper.minNumber',
    minSymbol: 'helper.minSymbol',
    minUpper: 'helper.minUpper',
    noMatch: 'helper.noMatch',
    noName: 'helper.noName',
    noSeqNumber: 'helper.noSeqNumber',
    noSpace: 'helper.noSpace',
    notNegative: 'helpet.notNegative',
    underage: 'helper.underage',
  },
  joyride: {
    tour: 'joyride.tour',
    dashboard: {
      welcome: {
        title: 'joyride.dashboard.welcome.title',
        content: 'joyride.dashboard.welcome.content',
      },
      openVenuesCard: {
        title: 'joyride.dashboard.openVenuesCard.title',
        content: 'joyride.dashboard.openVenuesCard.content',
      },
      sessionKpis: {
        title: 'joyride.dashboard.sessionKpis.title',
        content: 'joyride.dashboard.sessionKpis.content',
      },
      salesOverviewCard: {
        title: 'joyride.salesOverviewCard.title',
        content: 'joyride.salesOverviewCard.content',
      },
    },
    appPage: {
      title: 'joyride.appPage.title',
      content: 'joyride.appPage.content',
    },
    analyticsPage: {
      title: 'joyride.analyticsPage.title',
      content: 'joyride.analyticsPage.content',
    },
    tabsPage: {
      title: 'joyride.tabsPage.title',
      content: 'joyride.tabsPage.content',
    },
    inventoryPage: {
      title: 'joyride.inventoryPage.title',
      content: 'joyride.inventoryPage.content',
    },
    invoicesPage: {
      title: 'joyride.invoicesPage.title',
      content: 'joyride.invoicesPage.content',
    },
    menuPage: {
      title: 'joyride.menuPage.title',
      content: 'joyride.menuPage.content',
    },
    ordersPage: {
      title: 'joyride.ordersPage.title',
      content: 'joyride.ordersPage.content',
    },
    usersPage: {
      title: 'joyride.usersPage.title',
      content: 'joyride.usersPage.content',
    },
    venuesPage: {
      title: 'joyride.venuesPage.title',
      content: 'joyride.venuesPage.content',
    },
    securityPage: {
      title: 'joyride.securityPage.title',
      content: 'joyride.securityPage.content',
    },
    billingPage: {
      title: 'joyride.billingPage.title',
      content: 'joyride.billingPage.content',
    },
  },
  kpi: {
    ranking: 'kpi.ranking',
    totalIncome: 'kpi.totalIncome',
    entranceFeeIncome: 'kpi.entranceFeeIncome',
  },
  nav: {
    about: 'nav.about',
    academy: 'nav.academy',
    account: 'nav.account',
    activeOrders: 'nav.activeOrders',
    activeOrdersList: 'nav.activeOrdersList',
    app: 'nav.app',
    analytics: 'nav.analytics',
    auth: 'nav.auth',
    banking: 'nav.banking',
    billing: 'nav.billing',
    blog: 'nav.blog',
    booking: 'nav.booking',
    brokers: 'nav.brokers',
    browse: 'nav.browse',
    calendar: 'nav.calendar',
    canceledOrders: 'nav.canceledOrders',
    canceledOrdersList: 'nav.canceledOrdersList',
    cards: 'nav.cards',
    category: 'nav.category',
    categories: 'nav.categories',
    categoryList: 'nav.categoryList',
    chat: 'nav.chat',
    checkout: 'nav.checkout',
    concepts: 'nav.concepts',
    contact: 'nav.contact',
    course: 'nav.course',
    create: 'nav.create',
    crypto: 'nav.crypto',
    customer: 'nav.customer',
    customers: 'nav.customers',
    dashboard: 'nav.dashboard',
    details: 'nav.details',
    docs: 'nav.docs',
    ecommerce: 'nav.ecommerce',
    economicGroup: 'nav.economicGroup',
    edit: 'nav.edit',
    error: 'nav.error',
    feed: 'nav.feed',
    fileManager: 'nav.fileManager',
    files: 'nav.files',
    finance: 'nav.finance',
    fiscal: 'nav.fiscal',
    fleet: 'nav.fleet',
    forgotPassword: 'nav.forgotPassword',
    general: 'nav.general',
    globalMenu: 'nav.globalMenu',
    globalProduct: 'nav.globalProduct',
    home: 'nav.home',
    inactiveOrders: 'nav.inactiveOrders',
    inactiveOrdersList: 'nav.inactiveOrdersList',
    inactiveTabs: 'nav.inactiveTabs',
    inventory: 'nav.inventory',
    inventoryControl: 'nav.inventoryControl',
    inventoryStatement: 'nav.inventoryStatement',
    invoice: 'nav.invoice',
    invoiceDetails: 'nav.invoiceDetails',
    invoices: 'nav.invoices',
    invoiceKanban: 'nav.invoiceKanban',
    invoiceList: 'nav.invoiceList',
    jobList: 'nav.jobList',
    kanban: 'nav.kanban',
    list: 'nav.list',
    login: 'nav.login',
    logistics: 'nav.logistics',
    logout: 'nav.logout',
    mail: 'nav.mail',
    management: 'nav.management',
    menu: 'nav.menu',
    menus: 'nav.menus',
    notifications: 'nav.notifications',
    order: 'nav.order',
    orders: 'nav.orders',
    orderDetails: 'nav.orderDetails',
    orderList: 'nav.orderList',
    ordersKanban: 'nav.ordersKanban',
    ordersList: 'nav.ordersList',
    organization: 'nav.organization',
    organizationProfile: 'nav.organizationProfile',
    overview: 'nav.overview',
    pages: 'nav.pages',
    partners: 'nav.partners',
    payment: 'nav.payment',
    payouts: 'nav.payouts',
    policies: 'nav.policies',
    postCreate: 'nav.postCreate',
    postDetails: 'nav.postDetails',
    postList: 'nav.postList',
    pricing: 'nav.pricing',
    privacyPolicy: 'nav.privacyPolicy',
    product: 'nav.product',
    products: 'nav.products',
    productList: 'nav.productList',
    profile: 'nav.profile',
    recoverPassword: 'nav.recover',
    register: 'nav.register',
    resetPassword: 'nav.resetPassword',
    reports: 'nav.reports',
    role: 'nav.role',
    roles: 'nav.roles',
    roleList: 'nav.roleList',
    schedule: 'nav.schedule',
    timedMenus: 'nav.timedMenus',
    security: 'nav.security',
    settings: 'nav.settings',
    signUp: 'nav.signUp',
    socialMedia: 'nav.socialMedia',
    statement: 'nav.statement',
    stockEntry: 'nav.stockEntry',
    stockLoss: 'nav.stockLoss',
    supplier: 'nav.supplier',
    table: 'nav.table',
    tables: 'nav.tables',
    tab: 'nav.tab',
    tabs: 'nav.tabs',
    tabDetails: 'nav.tabDetails',
    tabsKanban: 'nav.tabsKanban',
    tabsList: 'nav.tabsList',
    terms: 'nav.terms',
    venue: 'nav.venue',
    venues: 'nav.venues',
    venueList: 'nav.venueList',
    venueScheduleTable: 'nav.venueScheduleTable',
    verifyCode: 'nav.verifyCode',
    verifyEmail: 'nav.verifyEmail',
    user: 'nav.user',
    users: 'nav.users',
    userList: 'nav.userList',
  },
  payment: {
    refund: {
      button: 'payment.refund.button',
      confirmTitle: 'payment.refund.confirmTitle',
      confirmMessage: 'payment.refund.confirmMessage',
      confirmMessagePix: 'payment.refund.confirmMessagePix',
      confirmHint: 'payment.refund.confirmHint',
      confirmHintPix: 'payment.refund.confirmHintPix',
      confirmAction: 'payment.refund.confirmAction',
      windowHours: 'payment.refund.windowHours',
    },
  },
  pages: {
    app: {
      bannerHeader: 'pages.app.bannerHeader',
      bannerSubtitle: 'pages.app.bannerSubtitle',
      bannerCTA: 'pages.app.bannerCTA',
      networkBanner: 'pages.app.networkBanner',
      networkBannerCta: 'pages.app.networkBannerCta',
      sessionByVenueTitle: 'pages.app.sessionByVenueTitle',
      sessionByVenueSubtitle: 'pages.app.sessionByVenueSubtitle',
      metricRevenue: 'pages.app.metricRevenue',
      metricActiveOrders: 'pages.app.metricActiveOrders',
      metricTabs: 'pages.app.metricTabs',
      metricAvgTicket: 'pages.app.metricAvgTicket',
    },
    fastpassCheckout: {
      formHeader: 'pages.fastpassCheckout.formHeader',
      formFooterStart: 'pages.fastpassCheckout.formFooterStart',
      formFooterEnd: 'pages.fastpassCheckout.formFooterEnd',
      initialFormSubtitle: 'pages.fastpassCheckout.initialFormSubtitle',
      paymentFormSubtitle: 'pages.fastpassCheckout.paymentFormSubtitle',
      paymentCompleteHeader: 'pages.fastpassCheckout.paymentCompleteHeader',
      paymentCompleteSubtitle: 'pages.fastpassCheckout.paymentCompleteSubtitle',
      choosePaymentMethod: 'pages.fastpassCheckout.choosePaymentMethod',
      payWithCard: 'pages.fastpassCheckout.payWithCard',
      payWithPix: 'pages.fastpassCheckout.payWithPix',
      pixScanHint: 'pages.fastpassCheckout.pixScanHint',
      pixCopyCode: 'pages.fastpassCheckout.pixCopyCode',
      pixCopied: 'pages.fastpassCheckout.pixCopied',
      pixAwaiting: 'pages.fastpassCheckout.pixAwaiting',
      pixExpiredTitle: 'pages.fastpassCheckout.pixExpiredTitle',
      pixExpiredMessage: 'pages.fastpassCheckout.pixExpiredMessage',
      cardPaymentError: 'pages.fastpassCheckout.cardPaymentError',
      confirmationFooter: 'pages.fastpassCheckout.confirmationFooter',
      wantReceiptPrompt: 'pages.fastpassCheckout.wantReceiptPrompt',
      receiptEmailPlaceholder: 'pages.fastpassCheckout.receiptEmailPlaceholder',
      sendReceipt: 'pages.fastpassCheckout.sendReceipt',
      receiptSent: 'pages.fastpassCheckout.receiptSent',
      noOrdersFound: 'pages.fastpassCheckout.noOrdersFound',
      noOrdersPlaced: 'pages.fastpassCheckout.noOrdersPlaced',
      confirmCloseStep: 'pages.fastpassCheckout.confirmCloseStep',
      confirmTabClose: 'pages.fastpassCheckout.confirmTabClose',
      zeroCloseTitle: 'pages.fastpassCheckout.zeroCloseTitle',
      zeroCloseMessage: 'pages.fastpassCheckout.zeroCloseMessage',
      zeroCloseHint: 'pages.fastpassCheckout.zeroCloseHint',
      zeroCloseFormSubtitle: 'pages.fastpassCheckout.zeroCloseFormSubtitle',
      zeroCloseCompleteSubtitle: 'pages.fastpassCheckout.zeroCloseCompleteSubtitle',
      zeroCloseConfirmationFooter: 'pages.fastpassCheckout.zeroCloseConfirmationFooter',
      zeroCloseError: 'pages.fastpassCheckout.zeroCloseError',
      rateLimitedError: 'pages.fastpassCheckout.rateLimitedError',
      sessionExpiredError: 'pages.fastpassCheckout.sessionExpiredError',
      tipLabel: 'pages.fastpassCheckout.tipLabel',
      tipHint: 'pages.fastpassCheckout.tipHint',
      tipNone: 'pages.fastpassCheckout.tipNone',
      tipPercent: 'pages.fastpassCheckout.tipPercent',
      tipCustom: 'pages.fastpassCheckout.tipCustom',
      tipCustomPlaceholder: 'pages.fastpassCheckout.tipCustomPlaceholder',
      tipApply: 'pages.fastpassCheckout.tipApply',
      tipError: 'pages.fastpassCheckout.tipError',
      handoffCodeLabel: 'pages.fastpassCheckout.handoffCodeLabel',
      copyCode: 'pages.fastpassCheckout.copyCode',
      showCodeAtCounter: 'pages.fastpassCheckout.showCodeAtCounter',
      exitCodeHint: 'pages.fastpassCheckout.exitCodeHint',
      pickupCodeHint: 'pages.fastpassCheckout.pickupCodeHint',
    },
    forbidden: {
      header: 'pages.forbidden.header',
      subtitle: 'pages.forbidden.subtitle',
      button: 'pages.forbidden.button',
    },
    globalMenu: {
      dialogSubtitle: 'pages.globalMenu.dialogSubtitle',
    },
    order: {
      kanbanSearchPlaceholder: 'pages.order.kanbanSearchPlaceholder',
      kanbanSearchEmpty: 'pages.order.kanbanSearchEmpty',
      captureRetry: 'pages.order.captureRetry',
      captureRetrySuccess: 'pages.order.captureRetrySuccess',
      captureBlockedTitle: 'pages.order.captureBlockedTitle',
      captureWaitingAuth: 'pages.order.captureWaitingAuth',
      captureWaitingAuthCta: 'pages.order.captureWaitingAuthCta',
      captureOk: 'pages.order.captureOk',
    },
    invoice: {
      codeDialogHeader: 'pages.invoice.codeDialogHeader',
      codeDialogText: 'pages.invoice.codeDialogText',
      leftFootnote: 'pages.invoice.leftFootnote',
      reminderDialogAlert: 'pages.invoice.reminderDialogAlert',
      reminderDialogHeader: 'pages.invoice.reminderDialogHeader',
      reminderDialogSubtitle: 'pages.invoice.reminderDialogSubtitle',
      reminderDialogText: 'pages.invoice.reminderDialogText',
      rightFootnote: 'pages.invoice.rightFootnote',
      updateDialogAlert: 'pages.invoice.updateDialogAlert',
      updateDialogAlertStrong: 'pages.invoice.updateDialogAlertStrong',
      updateDialogHeader: 'pages.invoice.updateDialogHeader',
      updateDialogText: 'pages.invoice.updateDialogText',
    },
    login: {
      formHeader: 'pages.login.formHeader',
      formSubtitle: 'pages.login.formSubtitle',
      noAccountText: 'pages.login.noAccountText',
      sideBanner: 'pages.login.sideBanner',
    },
    maintenance: {
      header: 'pages.maintenance.header',
      subtitle: 'pages.maintenance.subtitle',
      button: 'pages.maintenance.button',
    },
    notFound: {
      header: 'pages.notFound.header',
      subtitle: 'pages.notFound.subtitle',
      button: 'pages.notFound.button',
    },
    product: {
      details: 'pages.product.details',
      inventoryDescription: 'pages.product.inventoryDescription',
      switchDescription: 'pages.product.switchDescription',
      pricingAndInventory: 'pages.product.pricingAndInventory',
    },
    register: {
      formHeader: 'pages.register.formHeader',
      formSubtitle: 'pages.register.formSubtitle',
      formFooterStart: 'pages.register.formFooterStart',
      formFooterEnd: 'pages.register.formFooterEnd',
      existingAccountText: 'pages.register.existingAccountText',
      sideBanner: 'pages.register.sideBanner',
    },
    serverError: {
      header: 'pages.serverError.header',
      subtitle: 'pages.serverError.subtitle',
      button: 'pages.serverError.button',
    },
    signUp: {
      formHeader: 'pages.signUp.formHeader',
      formSubtitle: 'pages.signUp.formSubtitle',
      formFooterStart: 'pages.signUp.formFooterStart',
      formFooterEnd: 'pages.signUp.formFooterEnd',
      existingAccountText: 'pages.signUp.existingAccountText',
      sideBanner: 'pages.signUp.sideBanner',
    },
    resetPwrd: {
      formHeader: 'pages.resetPwrd.formHeader',
      formSubtitle: 'pages.resetPwrd.formSubtitle',
    },
    schedule: {
      formAlert: 'pages.schedule.formAlert',
      formHeader: 'pages.schedule.formHeader',
      formSubtitle: 'pages.schedule.formSubtitle',
      closesAt: 'pages.schedule.closesAt',
      openUntil: 'pages.schedule.openUntil',
      opensAt: 'pages.schedule.opensAt',
    },
    timedMenus: {
      title: 'pages.timedMenus.title',
      subtitle: 'pages.timedMenus.subtitle',
      menuName: 'pages.timedMenus.menuName',
      menuDefault: 'pages.timedMenus.menuDefault',
      priority: 'pages.timedMenus.priority',
      priorityHelp: 'pages.timedMenus.priorityHelp',
      menuSchedule: 'pages.timedMenus.menuSchedule',
      menuCategories: 'pages.timedMenus.menuCategories',
      noMenus: 'pages.timedMenus.noMenus',
      addMenu: 'pages.timedMenus.addMenu',
      editMenu: 'pages.timedMenus.editMenu',
      nameRequired: 'pages.timedMenus.nameRequired',
      noSchedulesHint: 'pages.timedMenus.noSchedulesHint',
      noCategoriesHint: 'pages.timedMenus.noCategoriesHint',
      upgradeRequired: 'pages.timedMenus.upgradeRequired',
      upgradeDescription: 'pages.timedMenus.upgradeDescription',
      upgradeCurrentPlan: 'pages.timedMenus.upgradeCurrentPlan',
      upgradeCta: 'pages.timedMenus.upgradeCta',
    },
    planLock: {
      upgradeCta: 'pages.planLock.upgradeCta',
      upgradeRequired: 'pages.planLock.upgradeRequired',
      upgradeCurrentPlan: 'pages.planLock.upgradeCurrentPlan',
      postpaidLegacy: 'pages.planLock.postpaidLegacy',
      title: {
        timedMenus: 'pages.planLock.title.timedMenus',
        tableQr: 'pages.planLock.title.tableQr',
        analytics: 'pages.planLock.title.analytics',
        postpaid: 'pages.planLock.title.postpaid',
        tabs: 'pages.planLock.title.tabs',
        inventory: 'pages.planLock.title.inventory',
      },
      description: {
        timedMenus: 'pages.planLock.description.timedMenus',
        tableQr: 'pages.planLock.description.tableQr',
        analytics: 'pages.planLock.description.analytics',
        postpaid: 'pages.planLock.description.postpaid',
        tabs: 'pages.planLock.description.tabs',
        inventory: 'pages.planLock.description.inventory',
      },
      featureLost: {
        timedMenus: 'pages.planLock.featureLost.timedMenus',
        tableQr: 'pages.planLock.featureLost.tableQr',
        analytics: 'pages.planLock.featureLost.analytics',
        postpaid: 'pages.planLock.featureLost.postpaid',
        tabs: 'pages.planLock.featureLost.tabs',
        inventory: 'pages.planLock.featureLost.inventory',
      },
    },
    tab: {
      clientFormHeader: 'pages.tab.clientFormHeader',
      clientFormSubtitle: 'pages.tab.clientFormSubtitle',
      tableFormBypassButton: 'pages.tab.tableFormBypassButton',
      tableFormSubtitle: 'pages.tab.tableFormSubtitle',
      tableNotAssigned: 'pages.tab.tableNotAssigned',
      codeDialogHeader: 'pages.tab.codeDialogHeader',
      codeDialogText: 'pages.tab.codeDialogText',
      exitCodeDialogText: 'pages.tab.exitCodeDialogText',
      entryQrDialogHeader: 'pages.tab.entryQrDialogHeader',
      entryQrDialogText: 'pages.tab.entryQrDialogText',
      exitQrDialogHeader: 'pages.tab.exitQrDialogHeader',
      exitQrDialogText: 'pages.tab.exitQrDialogText',
      exitQrIsEntryError: 'pages.tab.exitQrIsEntryError',
      entryQrIsExitError: 'pages.tab.entryQrIsExitError',
      exitQrIsOrderError: 'pages.tab.exitQrIsOrderError',
      exitQrTabMismatch: 'pages.tab.exitQrTabMismatch',
      tabIdDigitsOnly: 'pages.tab.tabIdDigitsOnly',
      leftFootnote: 'pages.tab.leftFootnote',
      noOrders: 'pages.tab.noOrders',
      kanbanSearchPlaceholder: 'pages.tab.kanbanSearchPlaceholder',
      kanbanSearchEmpty: 'pages.tab.kanbanSearchEmpty',
      orderSearchPlaceholder: 'pages.tab.orderSearchPlaceholder',
      orderEmptyMenu: 'pages.tab.orderEmptyMenu',
      orderReviewCta: 'pages.tab.orderReviewCta',
      orderCommentTitle: 'pages.tab.orderCommentTitle',
      orderCommentPlaceholder: 'pages.tab.orderCommentPlaceholder',
      orderReviewTitle: 'pages.tab.orderReviewTitle',
      orderConfirmCta: 'pages.tab.orderConfirmCta',
      orderSuccessTitle: 'pages.tab.orderSuccessTitle',
      orderSuccessCode: 'pages.tab.orderSuccessCode',
      orderBackToTab: 'pages.tab.orderBackToTab',
      orderAnother: 'pages.tab.orderAnother',
      orderViewDetails: 'pages.tab.orderViewDetails',
      orderStepMenu: 'pages.tab.orderStepMenu',
      orderStepReview: 'pages.tab.orderStepReview',
      orderStepDone: 'pages.tab.orderStepDone',
      orderNeedsTable: 'pages.tab.orderNeedsTable',
      orderTabNotOpen: 'pages.tab.orderTabNotOpen',
      reminderDialogAlert: 'pages.tab.reminderDialogAlert',
      reminderDialogHeader: 'pages.tab.reminderDialogHeader',
      reminderDialogSubtitle: 'pages.tab.reminderDialogSubtitle',
      reminderDialogText: 'pages.tab.reminderDialogText',
      rightFootnote: 'pages.tab.rightFootnote',
      updateDialogAlert: 'pages.tab.updateDialogAlert',
      updateDialogAlertStrong: 'pages.tab.updateDialogAlertStrong',
      updateDialogHeader: 'pages.tab.updateDialogHeader',
      updateDialogText: 'pages.tab.updateDialogText',
      venueStepHelper: 'pages.tab.venueStepHelper',
      entranceFee: {
        splitsHeader: 'pages.tab.entranceFee.splitsHeader',
        chargedAtClose: 'pages.tab.entranceFee.chargedAtClose',
        closeTotal: 'pages.tab.entranceFee.closeTotal',
        entryTotal: 'pages.tab.entranceFee.entryTotal',
        splitAccepted: 'pages.tab.entranceFee.splitAccepted',
        splitPending: 'pages.tab.entranceFee.splitPending',
        splitAwaitingEntry: 'pages.tab.entranceFee.splitAwaitingEntry',
        splitPresent: 'pages.tab.entranceFee.splitPresent',
        splitPaid: 'pages.tab.entranceFee.splitPaid',
        splitOther: 'pages.tab.entranceFee.splitOther',
        newTabLabel: 'pages.tab.entranceFee.newTabLabel',
        newTabHint: 'pages.tab.entranceFee.newTabHint',
        processingFee: 'pages.tab.entranceFee.processingFee',
      },
      paymentProgress: {
        header: 'pages.tab.paymentProgress.header',
        paid: 'pages.tab.paymentProgress.paid',
        remaining: 'pages.tab.paymentProgress.remaining',
        whoPaid: 'pages.tab.paymentProgress.whoPaid',
        owes: 'pages.tab.paymentProgress.owes',
      },
      minimumTopUp: {
        label: 'pages.tab.minimumTopUp.label',
        hint: 'pages.tab.minimumTopUp.hint',
        closeAlertTitle: 'pages.tab.minimumTopUp.closeAlertTitle',
        closeAlertMessage: 'pages.tab.minimumTopUp.closeAlertMessage',
      },
    },
    userProfile: {
      general: {
        scheduleSwitch: 'pages.userProfile.general.scheduleSwitch',
        scheduleSwitchTooltip: 'pages.userProfile.general.scheduleSwitchTooltip',
        scheduleSwitchDisabledTooltip: 'pages.userProfile.general.scheduleSwitchDisabledTooltip',
        statusSwitch: 'pages.userProfile.general.statusSwitch',
        statusSwitchDisabledTooltip: 'pages.userProfile.general.statusSwitchDisabledTooltip',
        roleDialogHeader: 'pages.userProfile.general.roleDialogHeader',
        roleDialogSubtitle: 'pages.userProfile.general.roleDialogSubtitle',
      },
      security: {
        altHeader: 'pages.userProfile.security.altHeader',
        header: 'pages.userProfile.security.header',
        helper: 'pages.userProfile.security.helper',
        listHeader: 'pages.userProfile.security.listHeader',
        listAltHeader: 'pages.userProfile.security.listAltHeader',
      },
      invite: {
        venuesHeader: 'pages.userProfile.invite.venuesHeader',
        venuesHelper: 'pages.userProfile.invite.venuesHelper',
        venuesRequired: 'pages.userProfile.invite.venuesRequired',
        pending: 'pages.userProfile.invite.pending',
        accepted: 'pages.userProfile.invite.accepted',
      },
    },
    organizationProfile: {
      helper: 'pages.organizationProfile.helper',
      missingOrg: 'pages.organizationProfile.missingOrg',
    },
    userList: {
      removeDialogHeader: 'pages.userList.removeDialogHeader',
      removeDialogBody: 'pages.userList.removeDialogBody',
      removeDialogBodyMany: 'pages.userList.removeDialogBodyMany',
      removeDialogNote: 'pages.userList.removeDialogNote',
    },
    venues: {
      noData: 'pages.venues.noData',
      noDataTitle: 'pages.venues.noDataTitle',
      bulkEditDialogHeader: 'pages.venues.bulkEditDialogHeader',
      bulkEditDialogSubtitle: 'pages.venues.bulkEditDialogSubtitle',
      overLimitBanner: 'pages.venues.overLimitBanner',
      overLimitShort: 'pages.venues.overLimitShort',
      overLimitTooltip: 'pages.venues.overLimitTooltip',
      overLimitCta: 'pages.venues.overLimitCta',
      overLimitViewCta: 'pages.venues.overLimitViewCta',
      networkHelpTitle: 'pages.venues.networkHelpTitle',
      networkHelp: 'pages.venues.networkHelp',
    },
    venueProfile: {
      readOnlyBanner: 'pages.venueProfile.readOnlyBanner',
      docs: {
        header: 'pages.venueProfile.docs.header',
        subtitle: 'pages.venueProfile.docs.subtitle',
      },
      general: {
        header: 'pages.venueProfile.general.header',
        entrance_feeSub: 'pages.venueProfile.general.entrance_feeSub',
        entrance_feeWeekdayHeader: 'pages.venueProfile.general.entrance_feeWeekdayHeader',
        entrance_feeWeekdaySub: 'pages.venueProfile.general.entrance_feeWeekdaySub',
        entrance_feeWeekdayPlaceholder: 'pages.venueProfile.general.entrance_feeWeekdayPlaceholder',
        entrance_feeWeekdayAfterCreate: 'pages.venueProfile.general.entrance_feeWeekdayAfterCreate',
        entrance_feePrepaidDisabled: 'pages.venueProfile.general.entrance_feePrepaidDisabled',
        entrance_feeCurrent: 'pages.venueProfile.general.entrance_feeCurrent',
        openstatusSwitch: 'pages.venueProfile.general.openstatusSwitch',
        openstatusSwitchTooltip: 'pages.venueProfile.general.openstatusSwitchTooltip',
        openstatusSwitchStatusTooltip: 'pages.venueProfile.general.openstatusSwitchStatusTooltip',
        openstatusSwitchReceivingTooltip: 'pages.venueProfile.general.openstatusSwitchReceivingTooltip',
        payment_modeSub: 'pages.venueProfile.general.payment_modeSub',
        service_modeSub: 'pages.venueProfile.general.service_modeSub',
        statusSwitch: 'pages.venueProfile.general.statusSwitch',
        statusSwitchTooltip: 'pages.venueProfile.general.statusSwitchTooltip',
        statusSwitchAltTooltip: 'pages.venueProfile.general.statusSwitchAltTooltip',
        statusSwitchLimitTooltip: 'pages.venueProfile.general.statusSwitchLimitTooltip',
        statusSwitchLimitCaption: 'pages.venueProfile.general.statusSwitchLimitCaption',
        settingsHeader: 'pages.venueProfile.general.settingsHeader',
        min_amountSub: 'pages.venueProfile.general.min_amountSub',
      },
      fiscal: {
        header: 'pages.venueProfile.fiscal.header',
        addressCheck: 'pages.venueProfile.fiscal.addressCheck',
        addressCheckSub: 'pages.venueProfile.fiscal.addressCheckSub',
      },
      payouts: {
        header: 'pages.venueProfile.payouts.header',
        subtitle: 'pages.venueProfile.payouts.subtitle',
        statusNotConnected: 'pages.venueProfile.payouts.statusNotConnected',
        statusOnboarding: 'pages.venueProfile.payouts.statusOnboarding',
        statusActive: 'pages.venueProfile.payouts.statusActive',
        statusReady: 'pages.venueProfile.payouts.statusReady',
        statusRestricted: 'pages.venueProfile.payouts.statusRestricted',
        notConnectedBody: 'pages.venueProfile.payouts.notConnectedBody',
        onboardingBody: 'pages.venueProfile.payouts.onboardingBody',
        activeBody: 'pages.venueProfile.payouts.activeBody',
        readyBody: 'pages.venueProfile.payouts.readyBody',
        restrictedBody: 'pages.venueProfile.payouts.restrictedBody',
        cta: 'pages.venueProfile.payouts.cta',
        continueCta: 'pages.venueProfile.payouts.continueCta',
        manageCta: 'pages.venueProfile.payouts.manageCta',
        setupTitle: 'pages.venueProfile.payouts.setupTitle',
        openDashboard: 'pages.venueProfile.payouts.openDashboard',
        fiscalRequired: 'pages.venueProfile.payouts.fiscalRequired',
        invalidCnpj: 'pages.venueProfile.payouts.invalidCnpj',
        sideHeader: 'pages.venueProfile.payouts.sideHeader',
        accountId: 'pages.venueProfile.payouts.accountId',
        feeLabel: 'pages.venueProfile.payouts.feeLabel',
        requirementsLabel: 'pages.venueProfile.payouts.requirementsLabel',
        noRequirements: 'pages.venueProfile.payouts.noRequirements',
        footer: 'pages.venueProfile.payouts.footer',
        genericError: 'pages.venueProfile.payouts.genericError',
        confirmTitle: 'pages.venueProfile.payouts.confirmTitle',
        confirmIntro: 'pages.venueProfile.payouts.confirmIntro',
        confirmDataHeader: 'pages.venueProfile.payouts.confirmDataHeader',
        confirmNextStep: 'pages.venueProfile.payouts.confirmNextStep',
        confirmContactEmailNote: 'pages.venueProfile.payouts.confirmContactEmailNote',
        confirmAddressFromVenue: 'pages.venueProfile.payouts.confirmAddressFromVenue',
        confirmAddressFromFiscal: 'pages.venueProfile.payouts.confirmAddressFromFiscal',
        confirmMissingValue: 'pages.venueProfile.payouts.confirmMissingValue',
        settlementToggle: 'pages.venueProfile.payouts.settlementToggle',
        settlementToggleHelp: 'pages.venueProfile.payouts.settlementToggleHelp',
        settlementToggleBlocked: 'pages.venueProfile.payouts.settlementToggleBlocked',
        settlementOn: 'pages.venueProfile.payouts.settlementOn',
        settlementOff: 'pages.venueProfile.payouts.settlementOff',
        reqGroup: {
          business: 'pages.venueProfile.payouts.reqGroup.business',
          company: 'pages.venueProfile.payouts.reqGroup.company',
          directors: 'pages.venueProfile.payouts.reqGroup.directors',
          executives: 'pages.venueProfile.payouts.reqGroup.executives',
          owners: 'pages.venueProfile.payouts.reqGroup.owners',
          representative: 'pages.venueProfile.payouts.reqGroup.representative',
          individual: 'pages.venueProfile.payouts.reqGroup.individual',
          bank: 'pages.venueProfile.payouts.reqGroup.bank',
          other: 'pages.venueProfile.payouts.reqGroup.other',
        },
        reqField: {
          productDescription: 'pages.venueProfile.payouts.reqField.productDescription',
          businessName: 'pages.venueProfile.payouts.reqField.businessName',
          mcc: 'pages.venueProfile.payouts.reqField.mcc',
          url: 'pages.venueProfile.payouts.reqField.url',
          supportPhone: 'pages.venueProfile.payouts.reqField.supportPhone',
          supportEmail: 'pages.venueProfile.payouts.reqField.supportEmail',
          directorsProvided: 'pages.venueProfile.payouts.reqField.directorsProvided',
          executivesProvided: 'pages.venueProfile.payouts.reqField.executivesProvided',
          ownersProvided: 'pages.venueProfile.payouts.reqField.ownersProvided',
          taxId: 'pages.venueProfile.payouts.reqField.taxId',
          phone: 'pages.venueProfile.payouts.reqField.phone',
          email: 'pages.venueProfile.payouts.reqField.email',
          fullName: 'pages.venueProfile.payouts.reqField.fullName',
          idNumber: 'pages.venueProfile.payouts.reqField.idNumber',
          politicalExposure: 'pages.venueProfile.payouts.reqField.politicalExposure',
          jobTitle: 'pages.venueProfile.payouts.reqField.jobTitle',
          idDocument: 'pages.venueProfile.payouts.reqField.idDocument',
          additionalDocument: 'pages.venueProfile.payouts.reqField.additionalDocument',
          address: 'pages.venueProfile.payouts.reqField.address',
          dob: 'pages.venueProfile.payouts.reqField.dob',
          relationship: 'pages.venueProfile.payouts.reqField.relationship',
          verification: 'pages.venueProfile.payouts.reqField.verification',
          bankAccount: 'pages.venueProfile.payouts.reqField.bankAccount',
          percentOwnership: 'pages.venueProfile.payouts.reqField.percentOwnership',
          relationshipExecutive: 'pages.venueProfile.payouts.reqField.relationshipExecutive',
          relationshipOwner: 'pages.venueProfile.payouts.reqField.relationshipOwner',
          relationshipDirector: 'pages.venueProfile.payouts.reqField.relationshipDirector',
          tosAcceptance: 'pages.venueProfile.payouts.reqField.tosAcceptance',
          tosDate: 'pages.venueProfile.payouts.reqField.tosDate',
          tosIp: 'pages.venueProfile.payouts.reqField.tosIp',
        },
      },
      menu: {
        productDialog: {
          subtitle: 'pages.venueProfile.menu.productDialog.subtitle',
        },
      },
      layout: {
        header: 'pages.venueProfile.layout.header',
        sub: 'pages.venueProfile.layout.sub',
      },
      inventory: {
        entryDialog: {
          subtitle: 'pages.venueProfile.inventory.entryDialog.subtitle',
        },
        historyDialog: {
          subtitle: 'pages.venueProfile.inventory.historyDialog.subtitle',
        },
      },
      security: {
        altHeader: 'pages.venueProfile.security.altHeader',
        header: 'pages.venueProfile.security.header',
        helper: 'pages.venueProfile.security.helper',
        listHeader: 'pages.venueProfile.security.listHeader',
        listAltHeader: 'pages.venueProfile.security.listAltHeader', 
      },
    },
    verifyCode: {
      formHeader: 'pages.verifyCode.formHeader',
      formSubtitleStart: 'pages.verifyCode.formSubtitleStart',
      formSubtitleEnd: 'pages.verifyCode.formSubtitleEnd',
      formFooter: 'pages.verifyCode.formFooter',
    },
    verifiedEmail: {
      header: 'pages.verifiedEmail.header',
    },
    billing: {
      currentPlan: 'pages.billing.currentPlan',
      venueLimit: 'pages.billing.venueLimit',
      venueLimitUnlimited: 'pages.billing.venueLimitUnlimited',
      venueLimitOne: 'pages.billing.venueLimitOne',
      nextRenewal: 'pages.billing.nextRenewal',
      noRenewal: 'pages.billing.noRenewal',
      venueUsage: 'pages.billing.venueUsage',
      venueUsageUnlimited: 'pages.billing.venueUsageUnlimited',
      cancelAtPeriodEnd: 'pages.billing.cancelAtPeriodEnd',
      cancelAtPeriodEndHint: 'pages.billing.cancelAtPeriodEndHint',
      managePortal: 'pages.billing.managePortal',
      refresh: 'pages.billing.refresh',
      refreshTooltip: 'pages.billing.refreshTooltip',
      adminsOnly: 'pages.billing.adminsOnly',
      changePlan: 'pages.billing.changePlan',
      subscribePlan: 'pages.billing.subscribePlan',
      monthly: 'pages.billing.monthly',
      annual: 'pages.billing.annual',
      perMonth: 'pages.billing.perMonth',
      perYear: 'pages.billing.perYear',
      free: 'pages.billing.free',
      onRequest: 'pages.billing.onRequest',
      feesLine: 'pages.billing.feesLine',
      processing: 'pages.billing.processing',
      pleaseWait: 'pages.billing.pleaseWait',
      contactUs: 'pages.billing.contactUs',
      policyFootnote: 'pages.billing.policyFootnote',
      pastDueAlert: 'pages.billing.pastDueAlert',
      pastDueUpdatePayment: 'pages.billing.pastDueUpdatePayment',
      incompleteAlert: 'pages.billing.incompleteAlert',
      incompleteCompletePayment: 'pages.billing.incompleteCompletePayment',
      pendingDowngradeAlert: 'pages.billing.pendingDowngradeAlert',
      globalPastDueAlert: 'pages.billing.globalPastDueAlert',
      globalPastDueDays: 'pages.billing.globalPastDueDays',
      globalPastDueToday: 'pages.billing.globalPastDueToday',
      globalPastDueOneDay: 'pages.billing.globalPastDueOneDay',
      locked: {
        title: 'pages.billing.locked.title',
        subtitle: 'pages.billing.locked.subtitle',
        subtitleStaff: 'pages.billing.locked.subtitleStaff',
        manageCta: 'pages.billing.locked.manageCta',
        logoutCta: 'pages.billing.locked.logoutCta',
      },
      status: {
        active: 'pages.billing.status.active',
        trialing: 'pages.billing.status.trialing',
        past_due: 'pages.billing.status.past_due',
        incomplete: 'pages.billing.status.incomplete',
        incomplete_expired: 'pages.billing.status.incomplete_expired',
        canceled: 'pages.billing.status.canceled',
        unpaid: 'pages.billing.status.unpaid',
        paused: 'pages.billing.status.paused',
        manual: 'pages.billing.status.manual',
        none: 'pages.billing.status.none',
      },
      cta: {
        current: 'pages.billing.cta.current',
        switchToAnnual: 'pages.billing.cta.switchToAnnual',
        switchToMonthly: 'pages.billing.cta.switchToMonthly',
        downgradeScheduled: 'pages.billing.cta.downgradeScheduled',
        nextCycle: 'pages.billing.cta.nextCycle',
        talkToSales: 'pages.billing.cta.talkToSales',
        backToStarter: 'pages.billing.cta.backToStarter',
        downgrade: 'pages.billing.cta.downgrade',
        subscribe: 'pages.billing.cta.subscribe',
        upgrade: 'pages.billing.cta.upgrade',
      },
      confirm: {
        title: 'pages.billing.confirm.title',
        calculating: 'pages.billing.confirm.calculating',
        checkoutInfo: 'pages.billing.confirm.checkoutInfo',
        scheduledInfo: 'pages.billing.confirm.scheduledInfo',
        immediateInfo: 'pages.billing.confirm.immediateInfo',
        amountDueNow: 'pages.billing.confirm.amountDueNow',
        nextInvoices: 'pages.billing.confirm.nextInvoices',
        goCheckout: 'pages.billing.confirm.goCheckout',
        confirmSchedule: 'pages.billing.confirm.confirmSchedule',
        confirmCharge: 'pages.billing.confirm.confirmCharge',
        impactTitle: 'pages.billing.confirm.impactTitle',
        impactKeepUntil: 'pages.billing.confirm.impactKeepUntil',
        venueExcess: 'pages.billing.confirm.venueExcess',
        venueAutoDeactivate: 'pages.billing.confirm.venueAutoDeactivate',
        venueManageLink: 'pages.billing.confirm.venueManageLink',
        acknowledge: 'pages.billing.confirm.acknowledge',
      },
      starterCancel: {
        title: 'pages.billing.starterCancel.title',
        body: 'pages.billing.starterCancel.body',
        openPortal: 'pages.billing.starterCancel.openPortal',
        impactTitle: 'pages.billing.starterCancel.impactTitle',
        venueExcess: 'pages.billing.starterCancel.venueExcess',
        venueAutoDeactivate: 'pages.billing.starterCancel.venueAutoDeactivate',
        acknowledge: 'pages.billing.starterCancel.acknowledge',
      },
      pendingVenueExcess: 'pages.billing.pendingVenueExcess',
      enforceDeactivatedAlert: 'pages.billing.enforceDeactivatedAlert',
      snackbar: {
        loadError: 'pages.billing.snackbar.loadError',
        portalError: 'pages.billing.snackbar.portalError',
        alreadyOnPlan: 'pages.billing.snackbar.alreadyOnPlan',
        previewError: 'pages.billing.snackbar.previewError',
        downgradeScheduled: 'pages.billing.snackbar.downgradeScheduled',
        cycleToMonthlyScheduled: 'pages.billing.snackbar.cycleToMonthlyScheduled',
        cycleToAnnual: 'pages.billing.snackbar.cycleToAnnual',
        upgrade: 'pages.billing.snackbar.upgrade',
        updated: 'pages.billing.snackbar.updated',
        changeError: 'pages.billing.snackbar.changeError',
        updateCardHint: 'pages.billing.snackbar.updateCardHint',
      },
      customBanner: {
        name: 'pages.billing.customBanner.name',
        body: 'pages.billing.customBanner.body',
      },
      tier: {
        starter: {
          tagline: 'pages.billing.tier.starter.tagline',
          h1: 'pages.billing.tier.starter.h1',
          h2: 'pages.billing.tier.starter.h2',
          h3: 'pages.billing.tier.starter.h3',
          h4: 'pages.billing.tier.starter.h4',
          h5: 'pages.billing.tier.starter.h5',
          h6: 'pages.billing.tier.starter.h6',
          h7: 'pages.billing.tier.starter.h7',
        },
        essential: {
          tagline: 'pages.billing.tier.essential.tagline',
          h1: 'pages.billing.tier.essential.h1',
          h2: 'pages.billing.tier.essential.h2',
          h3: 'pages.billing.tier.essential.h3',
          h4: 'pages.billing.tier.essential.h4',
          h5: 'pages.billing.tier.essential.h5',
          h6: 'pages.billing.tier.essential.h6',
        },
        pro: {
          tagline: 'pages.billing.tier.pro.tagline',
          h1: 'pages.billing.tier.pro.h1',
          h2: 'pages.billing.tier.pro.h2',
          h3: 'pages.billing.tier.pro.h3',
          h4: 'pages.billing.tier.pro.h4',
          h5: 'pages.billing.tier.pro.h5',
          h6: 'pages.billing.tier.pro.h6',
          h7: 'pages.billing.tier.pro.h7',
          h8: 'pages.billing.tier.pro.h8',
          h9: 'pages.billing.tier.pro.h9',
          h10: 'pages.billing.tier.pro.h10',
        },
        enterprise: {
          tagline: 'pages.billing.tier.enterprise.tagline',
          h1: 'pages.billing.tier.enterprise.h1',
          h2: 'pages.billing.tier.enterprise.h2',
          h3: 'pages.billing.tier.enterprise.h3',
          h4: 'pages.billing.tier.enterprise.h4',
          h5: 'pages.billing.tier.enterprise.h5',
          h6: 'pages.billing.tier.enterprise.h6',
          h7: 'pages.billing.tier.enterprise.h7',
          h8: 'pages.billing.tier.enterprise.h8',
          h9: 'pages.billing.tier.enterprise.h9',
          h10: 'pages.billing.tier.enterprise.h10',
          h11: 'pages.billing.tier.enterprise.h11',
        },
        custom: {
          name: 'pages.billing.tier.custom.name',
          tagline: 'pages.billing.tier.custom.tagline',
        },
      },
    },
  },
  shortpayment_modes: {
    prepaid: 'shortpayment_modes.prepaid',
    postpaid: 'shortpayment_modes.postpaid',
  },
  payment_modes: {
    prepaid: 'payment_modes.prepaid',
    postpaid: 'payment_modes.postpaid',
  },
  popover: {
    tenant: {
      header: 'popover.tenant.header',
      subtitle: 'popover.tenant.subtitle',
      generalTitle: 'popover.tenant.generalTitle',
      viewOrganization: 'popover.tenant.viewOrganization',
    }
  },
  tenantContext: {
    showingVenue: 'tenantContext.showingVenue',
    showingOrganization: 'tenantContext.showingOrganization',
    onboardingMessage: 'tenantContext.onboardingMessage',
    onboardingCta: 'tenantContext.onboardingCta',
    searchPlaceholder: 'tenantContext.searchPlaceholder',
    recent: 'tenantContext.recent',
    openOrdersCount: 'tenantContext.openOrdersCount',
    closed: 'tenantContext.closed',
    noResults: 'tenantContext.noResults',
    currentPlan: 'tenantContext.currentPlan',
    venueLimitUsage: 'tenantContext.venueLimitUsage',
    venueLimitUsageUnlimited: 'tenantContext.venueLimitUsageUnlimited',
  },
  security: {
    viewAllProfiles: 'security.viewAllProfiles',
    // Pick one/other in code — locale `br` is Breton to i18next, not Portuguese.
    userCount_one: 'security.userCount_one',
    userCount_other: 'security.userCount_other',
    noUsersOnProfile: 'security.noUsersOnProfile',
  },
  roles: {
    admin: 'roles.admin',
    bar: 'roles.bar',
    bartender: 'roles.bartender',
    cook: 'roles.cook',
    finance: 'roles.finance',
    investor: 'roles.investor',
    kitchen: 'roles.kitchen',
    manager: 'roles.manager',
    waiter: 'roles.waiter',
  },
  shortservice_modes: {
    counter: 'shortservice_modes.counter',
    hybrid: 'shortservice_modes.hybrid',
    table: 'shortservice_modes.table',
  },
  service_modes: {
    counter: 'service_modes.counter',
    hybrid: 'service_modes.hybrid',
    table: 'service_modes.table',
  },
  settings: {
    themeMode: 'settings.themeMode',
  },
  snackbar: {
    codeSent: {
      error: 'snackbar.codeSent.error',
      success: 'snackbar.codeSent.success',
    },
    codeValidation: {
      error: 'snackbar.codeValidation.error',
      success: 'snackbar.codeValidation.success',
    },
    create: {
      error: 'snackbar.create.error',
      success: 'snackbar.create.success',
    },
    createTab: {
      error: {
        existingAnotherVenue: 'snackbar.createTab.error.existingAnotherVenue',
        existingSameVenue: 'snackbar.createTab.error.existingSameVenue',
        payment_modeMismatch: 'snackbar.createTab.error.payment_modeMismatch',
        venueClosed: 'snackbar.createTab.error.venueClosed',
        venueDenied: 'snackbar.createTab.error.venueDenied',
        venueInactive: 'snackbar.createTab.error.venueInactive',
      },
      success: 'snackbar.createTab.success',
    },
    delete: {
      error: 'snackbar.delete.error',
      success: 'snackbar.delete.success',
    },
    entryValidation: {
      error: 'snackbar.entryValidation.error',
      success: 'snackbar.entryValidation.success',
    },
    exitValidation: {
      error: 'snackbar.exitValidation.error',
      success: 'snackbar.exitValidation.success',
    },
    fetch: {
      error: 'snackbar.fetch.error',
      success: 'snackbar.fetch.success',
    },
    fileUpload: {
      error: 'snackbar.fileUpload.error',
      success: 'snackbar.fileUpload.success',
    },
    inventoryEntry: {
      error: 'snackbar.inventoryEntry.error',
      success: 'snackbar.inventoryEntry.success',
    },
    inventoryLoss: {
      error: 'snackbar.inventoryLoss.error',
      success: 'snackbar.inventoryLoss.success',
    },
    notification: {
      error: 'snackbar.notification.error',
      success: 'snackbar.notification.success',
    },
    passwordChange: {
      error: 'snackbar.passwordChange.error',
      success: 'snackbar.passwordChange.success',
    },
    resetPassword: {
      error: 'snackbar.resetPassword.error',
      success: 'snackbar.resetPassword.success',
    },
    resetPasswordEmail: {
      error: 'snackbar.resetPasswordEmail.error',
      success: 'snackbar.resetPasswordEmail.success',
    },
    resendInvite: {
      error: 'snackbar.resendInvite.error',
      success: 'snackbar.resendInvite.success',
    },
    refund: {
      error: 'snackbar.refund.error',
      success: 'snackbar.refund.success',
      windowExpired: 'snackbar.refund.windowExpired',
    },
    signUp: {
      error: 'snackbar.signUp.error',
      success: 'snackbar.signUp.success',
    },
    update: {
      error: 'snackbar.update.error',
      success: 'snackbar.update.success',
      venueActivatePlanLimit: 'snackbar.update.venueActivatePlanLimit',
      venueOpenStatusRequired: 'snackbar.update.venueOpenStatusRequired',
      venueOpenVerifiedRequired: 'snackbar.update.venueOpenVerifiedRequired',
      venueOpenReceivingRequired: 'snackbar.update.venueOpenReceivingRequired',
      venueBulkAccessDenied: 'snackbar.update.venueBulkAccessDenied',
    },
    verifyEmail: {
      error: 'snackbar.verifyEmail.error',
      success: 'snackbar.verifyEmail.success',
    },
  },
  status: {
    label: {
      active: 'status.label.active',
      analyzing: 'status.label.analyzing',
      approved: 'status.label.approved',
      canceled: 'status.label.canceled',
      closed: 'status.label.closed',
      closing: 'status.label.closing',
      completed: 'status.label.completed',
      connected: 'status.label.connected',
      declined: 'status.label.declined',
      disconnected: 'status.label.disconnected',
      fulfilled: 'status.label.fulfilled',
      inactive: 'status.label.inactive',
      inStock: 'status.label.inStock',
      lowStock: 'status.label.lowStock',
      onSale: 'status.label.onSale',
      outOfStock: 'status.label.outOfStock',
      open: 'status.label.open',
      opened: 'status.label.opened',
      paid: 'status.label.paid',
      paymentPending: 'status.label.paymentPending',
      paymentReceived: 'status.label.paymentReceived',
      paymentRefunded: 'status.label.paymentRefunded',
      paymentRejected: 'status.label.paymentRejected',
      paymentFailed: 'status.label.paymentFailed',
      pending: 'status.label.pending',
      preparing: 'status.label.preparing',
      ready: 'status.label.ready',
      readyGeneric: 'status.label.readyGeneric',
      readyTable: 'status.label.readyTable',
      readyTableGeneric: 'status.label.readyTableGeneric',
      received: 'status.label.received',
      reconnecting: 'status.label.reconnecting',
      sent: 'status.label.sent',
    },
    step: {
      cancel: 'status.step.cancel',
      complete: 'status.step.complete',
      finishPrep: 'status.step.finishPrep',
      receive: 'status.step.receive',
      startPrep: 'status.step.startPrep',
    },
    stepAction: {
      delivered: 'status.stepAction.delivered',
      finishedPreparation: 'status.stepAction.finishedPreparation',
      orderCanceled: 'status.stepAction.orderCanceled',
      orderDelivered: 'status.stepAction.orderDelivered',
      orderDeliveredToTable: 'status.stepAction.orderDeliveredToTable',
      orderReceived: 'status.stepAction.orderReceived',
      orderRefunded: 'status.stepAction.orderRefunded',
      paid: 'status.stepAction.paid',
      paymentFailed: 'status.stepAction.paymentFailed',
      paymentRefunded: 'status.stepAction.paymentRefunded',
      startedClosing: 'status.stepAction.startedClosing',
      startedPreparation: 'status.stepAction.startedPreparation',
      tabCanceled: 'status.stepAction.tabCanceled',
      tabFulfilled: 'status.stepAction.tabFulfilled',
      tabPaid: 'status.stepAction.tabPaid',
      tabRefunded: 'status.stepAction.tabRefunded',
      tabOpened: 'status.stepAction.tabOpened',
    },
  },
  tables: {
    openVenues: 'tables.openVenues',
    noOpenVenues: 'tables.noOpenVenues',
    productRanking: 'tables.productRanking',
    emptyLayout: 'tables.emptyLayout',
    viewList: 'tables.viewList',
    viewMap: 'tables.viewMap',
    qrAfterSave: 'tables.qrAfterSave',
    addMultiplePrompt: 'tables.addMultiplePrompt',
    invalidateQr: 'tables.invalidateQr',
    invalidateQrConfirm: 'tables.invalidateQrConfirm',
    assignRequired: 'tables.assignRequired',
    assignOptional: 'tables.assignOptional',
    assignDialog: 'tables.assignDialog',
    changeTable: 'tables.changeTable',
    clearTable: 'tables.clearTable',
    deliveryHint: 'tables.deliveryHint',
    openExistingTab: 'tables.openExistingTab',
    status: {
      available: 'tables.status.available',
      occupied: 'tables.status.occupied',
      reserved: 'tables.status.reserved',
      disabled: 'tables.status.disabled',
    },
  },
  tags: {
    containsAlcohol: 'tags.containsAlcohol',
    nonAlcoholic: 'tags.nonAlcoholic',
    type: 'tags.type',
  },
  venueTypes: {
      bar: 'venueTypes.bar',
      nightClub: 'venueTypes.nightClub',
      restaurant: 'venueTypes.restaurant',
      events: 'venueTypes.events',
  },
  weekdays: {
    monday: 'weekdays.monday',
    tuesday: 'weekdays.tuesday',
    wednesday: 'weekdays.wednesday',
    thursday: 'weekdays.thursday',
    friday: 'weekdays.friday',
    saturday: 'weekdays.saturday',
    sunday: 'weekdays.sunday',
  }
};
